const request = (method, url, body = null) => {
  const opts = {
    method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    cache: 'no-store',
  };

  if (body) {
    opts.body = JSON.stringify(body);
  }
  return fetch(url, opts);
};

export const get = (url) =>
  request('GET', url);

export const post = (url, body) =>
  request('POST', url, body);

export const put = (url, body) =>
  request('PUT', url, body);

export const del = (url, body) =>
  request('DELETE', url, body);



// WEBPACK FOOTER //
// ./src/app/utils/http.js